<div class="container">
    <section>
        <div class="row">
            <div class="col-md-8 col-md-offset-2 ">
                <h1>Gestión de Usuario</h1>
                <hr>
                <div class="row">
                    <div class="col-sm-12">
                        <button routerLink="/alta-usuario" class="btn btn-success">Alta de Usuario</button>
                    </div>
                </div>
                <table id="datatable-buttons" datatable [dtTrigger]="dtTrigger" [dtOptions]="dtOptions"
                    class="table table-striped table-bordered">
                    <thead>
                        <tr>
                            <th>Nombre Usuario</th>
                            <th>Nombre</th>
                            <th>Apellido</th>
                            <th>DNI</th>
                            <th>Email</th>
                            <th>Estado</th>
                            <th>Acción</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let usuario of usuarios">
                            <td>{{usuario.username}}</td>
                            <td>{{usuario.nombre}}</td>
                            <td>{{usuario.apellido}}</td>
                            <td *ngIf="usuario.documento == null">NA</td>
                            <td *ngIf="usuario.documento != null">{{usuario.documento.numeroDocumento}}</td>
                            <td>{{usuario.email}}</td>
                            <th *ngIf="usuario.fechaBaja != null">Inactivo</th>
                            <th *ngIf="usuario.fechaBaja == null">Activo</th>
                            <td class="text-center">
                                <a class="link" (click)="editarUsuario(usuario)"><i class="fa fa-edit"></i></a>
                                &nbsp; &nbsp;
                                <a class="link" *ngIf="usuario.fechaBaja == null && usuario.idUsuario != usuarioLogeado" (click)="eliminarUsuario(usuario.idUsuario)"><i class="fa fa-trash"></i></a>
                                <a class="link" *ngIf="usuario.fechaBaja != null" (click)="activarUsuario(usuario.idUsuario)"><i class="fa fa-check-square-o"></i></a>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <br>
                <br>
                <div class="row">
                    <div class="col-sm-12">
                        <button routerLink="/home" class="btn btn-link">Volver</button>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>